import { GettingStartedCard } from "@components/Cards";

export const GettingStartedPage = () => {
  return <GettingStartedCard />;
};
